import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from 'app/shared/services/auth.service';
import { Permiso } from 'app/main/utilerias/models/usuarios/permiso';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { agGridClientesDefs } from '../../../models/contratantes-defs';
import { ClientesService } from 'app/main/clientes/services/clientes.service';
import { ColumnApi, RowNode } from 'ag-grid-community';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { debounce, debounceTime, distinct, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-busqueda-clientes',
  templateUrl: './busqueda-clientes.component.html',
  styleUrls: ['./busqueda-clientes.component.css']
})
export class BusquedaClientesComponent implements OnInit {

  title: string;
  message: string;
  permisos: Permiso;
  private gridApi;
  private gridColumnApi: ColumnApi;
  @BlockUI('listadoPolizas') blockUI: NgBlockUI;

  clientesForm: FormGroup;
  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  rowData: any[] = [];
  columnDefs = agGridClientesDefs;

  get clienteControl(): any { return this.clientesForm.controls.cliente; }

  constructor(private dialogRef: MatDialogRef<BusquedaClientesComponent>, @Inject(MAT_DIALOG_DATA) data,
    private authService: AuthService, private fb: FormBuilder, private clientesService: ClientesService) {
    this.title = data.title;
    this.message = data.message;

    this.permisos = this.authService.obtenerPermisoPorOpcion('Usuarios');
  }

  ngOnInit(): void {
    this.clientesForm = this.fb.group({
      cliente: new FormControl()
    });

    this.clientesForm.controls.cliente.valueChanges.pipe(debounceTime(1000),distinctUntilChanged()).subscribe((valor: string) => {
      if (valor.length > 0) {
        this.blockUI.start('Realizando busqueda...');
        this.clientesService.obtenerClientesBusqueda(valor).subscribe(clientes => {
          this.rowData = clientes.cliente;
          this.gridColumnApi.autoSizeAllColumns();
          this.blockUI.stop();
        });
      } 

    });
  }


  /**
   * Al aceptar cualquier accion enviamos true de que se desea proceder con la accion.
   */
  buscar(): void {
    
  }

  /**
   * Al cancelar la operacion enviamos false para que no se realice ninguna accion.
   */
  cancelar(): void {
    this.dialogRef.close(false);
  }

  onRowDoubleClick(fila) {
    this.dialogRef.close(fila.data);
  }

  /**
  * Se ejecuta este metodo cuando el grid esta renderizado y re ajusta el tamaño de las celdas cuando se cambia de tamaño la pantalla.
  * @param params grid framework object
  */
  onGridReady(params): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

    // tslint:disable-next-line:typedef
    window.addEventListener('resize', () => {
      // tslint:disable-next-line:typedef
      setTimeout(() => {
        this.gridColumnApi.autoSizeAllColumns();
      });
    });
  }


}
